<template>
  <span class="name-code">
    <span class="name">{{ params?.name || params?.displayName || '' }}</span>
    <span v-if="code" class="code">- {{ code }}</span>
  </span>
</template>

<script>
export default {
  name: "ParamsNameWithCodeHeader",
  // props: { params: { type: Object, required: true } },
  computed: {
    code() {
      try { return this.params?.userData?.code || ''; } catch (_) { return ''; }
    }
  }
};
</script>

<style scoped>
.name-code { display: inline-flex; align-items: center; gap: 6px; }
.name { color: #111827; }  /* gray-900 */
.code { color: #9ca3af; }  /* gray-400 */
</style>
